<mat-form-field>
  <mat-label>{{ label }}</mat-label>

  <mat-select required [formControl]="control" [required]="isRequired(control)">
    @for (option of options; track $index) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>

  @if (control.invalid) {
    <mat-error>{{ control.errors | json }}</mat-error>
  }
</mat-form-field>
